import { IFreeBet, IFreeBetSpin } from '../defaultObjects';
import { Utils } from '@/utils/Utils';
import { ActionContext } from 'vuex';

type State = {
  freeBets: IFreeBet[];
  freeBetSpins: IFreeBetSpin[];
};

export default {
  state: {
    freeBets: [],
    freeBetSpins: []
  },
  getters: {
    hasFreeBet(state: State) {
      return state.freeBets.length > 0;
    },
    getCurrentFreeBetProgress(state: State, getters: any) {
      if (!getters.hasFreeBet) return 0;

      const freeBet = state.freeBets[0];

      if (getters.isFreeBetRoundsCondition) {
        return freeBet.progress.rounds?.current;
      } else if (getters.isFreeBetBetsCondition) {
        return Utils.centsToMoneyStr(
          Number(freeBet.progress.bets?.current),
          freeBet.info.currency.decimals,
          freeBet.info.currency.code
        );
      }
    },
    getTotalFreeBetProgress(state: State, getters: any) {
      if (!getters.hasFreeBet) return 0;

      const freeBet = state.freeBets[0];

      if (getters.isFreeBetRoundsCondition) {
        return freeBet.progress.rounds?.total;
      } else if (getters.isFreeBetBetsCondition) {
        return Utils.centsToMoneyStr(
          Number(freeBet.progress.bets?.total),
          freeBet.info.currency.decimals,
          freeBet.info.currency.code
        );
      }
    },

    isFreeBetRoundsCondition(state: State, getters: any) {
      return Boolean(getters.hasFreeBet && state.freeBets[0].progress.rounds);
    },
    isFreeBetBetsCondition(state: State, getters: any) {
      return Boolean(getters.hasFreeBet && state.freeBets[0].progress.bets);
    },
    getFreeBetClosedTime(state: State, getters: any) {
      if (!getters.hasFreeBet) return '';

      return state.freeBets[0].time.finishedAt;
    },
    getFreeBetSpins(state: State) {
      return state.freeBetSpins;
    },
    getFreeBets(state: State) {
      return state.freeBets;
    },
    isShowFreeBetWelcomePopup(state: State, getters: any) {
      return getters.hasFreeBet && getters.isShowTabWelcome;
    },
    getFreeBetStartData(state: State, getters: any) {
      if (!getters.hasFreeBet) return '';

      return Utils.formatDate(new Date(state.freeBets[0].time.startedAt));
    },
    getFreeBetFinishData(state: State, getters: any) {
      if (!getters.hasFreeBet) return '';

      return Utils.formatDate(new Date(state.freeBets[0].time.finishedAt));
    },
    getFreeBetMinBet(state: State, getters: any) {
      return (
        getters.hasFreeBet &&
        Utils.centsToMoneyStr(
          state.freeBets[0].info.minBet,
          state.freeBets[0].info.currency.decimals,
          state.freeBets[0].info.currency.code
        )
      );
    },
    getFreeBetCurrencyCode(state: State, getters: any) {
      return getters.hasFreeBet && state.freeBets[0].info.currency.code;
    },
    getMaxFreeBetsForPlayer(state: State, getters: any) {
      return getters.hasFreeBet && state.freeBets[0].info.dailyPlayerLimit;
    },
    getMaxFreeBetsForDay(state: State, getters: any) {
      return getters.hasFreeBet && state.freeBets[0].info.betCount;
    },
    getArchiveFreeBetSpins(state: State) {
      return state.freeBetSpins.filter((spin: IFreeBetSpin) => spin.info.isArchive);
    },
    getActiveFreeBetSpins(state: State) {
      return state.freeBetSpins.filter((spin: IFreeBetSpin) => !spin.info.isArchive);
    }
  },
  mutations: {
    setFreeBetsData(state: State, data: IFreeBet[]) {
      if (!data) return;

      state.freeBets = JSON.parse(JSON.stringify(data));
    },

    setFreeBetSpinsData(state: State, data: IFreeBetSpin[]) {
      if (!data) return;

      state.freeBetSpins = JSON.parse(JSON.stringify(data));
    },
    clearFreeBet(state: State) {
      state.freeBets = [];
    }
  },
  actions: {
    SET_FREE_BETS_DATA({ commit }: ActionContext<any, any>, data: IFreeBet[]) {
      commit('setFreeBetsData', data);
    },
    SET_FREE_BET_SPINS_DATA({ commit }: ActionContext<any, any>, data: IFreeBetSpin[]) {
      commit('setFreeBetSpinsData', data);
    },
    CLEAR_FREE_BET({ commit }: ActionContext<any, any>) {
      commit('clearFreeBet');
    }
  }
};
